'use strict';

exports.__esModule = true;

exports.default = function (str) {
  return str.replace(/\s/g, '');
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/colormin/dist/lib/stripWhitespace.js
// module id = 2340
// module chunks = 0